import React from 'react';

import { Chip } from 'e100-react-components';
import { ChipProps } from 'e100-react-components';
import { useStyles } from './styles';

export const SmallChip = ({
  label
}: SmallChipProps) => {
  const classes = useStyles();

  return (
    <Chip  
      label={label}
      color="primary"
      size={'small'}
      classes={{ root: classes.chip }}
    />
  );
};

interface SmallChipProps extends Pick<
  ChipProps,
  'label'
> {}
